import CONFIG from "../config/config";

const ADDITIONAL_SYMBOLS_AWS_REQUIRES = /[!'()*]/g;

export const isLargeFile = (file: File) => {
    const limit = CONFIG.HEAVY_FILE_THRESHOLD * 1024 * 1024;
    return file.size > limit;
}

export const isVideoFile = (url: string): boolean => {
    const videoExtensions = CONFIG.VIDEO_TYPES;
    const lowerUrl = url.toLowerCase();
    return videoExtensions.some(ext => lowerUrl.endsWith(ext));
}

export const isImageFile = (url: string): boolean => {
    const imageExtensions = CONFIG.IMAGE_TYPES;
    return imageExtensions.some(ext => url.toLowerCase().endsWith(ext));
}

export const shouldBePreCompressed = (file: File) => {
    const limit = CONFIG.SHOULD_BE_PRECOMPRESSED * 1024 * 1024;
    return file.size > limit;
}

export const shouldBeResized = (file: File, maxWidth = 1500, maxHeight = 1500) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = URL.createObjectURL(file);
      img.onload = () => {
        resolve(img.width > maxWidth || img.height > maxHeight);
      };
      img.onerror = (error) => reject(error);
    });
  }

export const urlEncode = (text: string) => {
    let normalizedString = text.normalize('NFD');
    normalizedString = normalizedString.replace(/\s+/g, '_');
    let encoded = encodeURIComponent(normalizedString);
    return encoded;
}

export const s3Encode = (text: string) => {
    let normalizedString = text.normalize('NFD');
    normalizedString = normalizedString.replace(/\s+/g, '_');
    return normalizedString.replace(ADDITIONAL_SYMBOLS_AWS_REQUIRES, function(c) {
        return '%' + c.charCodeAt(0).toString(16);
    });
}

export const urlAndS3Encode = (text: string) => {
    return s3Encode(urlEncode(text));
}

/**
 * Extracts the filename from a full S3 URL.
 * This function handles cases where the filename contains special characters like '#'
 * that would be misinterpreted as URL fragments by the URL parser.
 * 
 * @param fullUrl - The full S3 URL (e.g., "https://bucket.s3.region.amazonaws.com/path/to/file#name.png")
 * @returns The filename extracted from the URL path
 */
export const extractFilenameFromUrl = (fullUrl: string): string => {
    try {
        const urlWithoutQuery = fullUrl.split('?')[0];
        const pathParts = urlWithoutQuery.split('/');
        const filename = pathParts[pathParts.length - 1];
        
        return filename;
    } catch (error) {
        try {
            const url = new URL(fullUrl);
            return url.pathname.split('/').pop() || '';
        } catch {
            return '';
        }
    }
}